import {FILE_VIEWER_SET} from "./available";

export default {
    [FILE_VIEWER_SET] (state, {source, title, mimeType, downloadFileName}) {
        state.fileViewerData.file = {
            source,
            title,
            mimeType,
            downloadFileName
        }
    },
}